import { useState } from 'react';
import * as Sentry from '@sentry/react';

// ----------------------------------------------------------------------

type CopiedValue = string | null;

type CopyFn = (text: string) => Promise<boolean>;

type ReturnType = {
  copy: CopyFn;
  copiedText: CopiedValue;
};

export function useCopyToClipboard(): ReturnType {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          component: 'useCopyToClipboard',
          action: 'copy',
        },
        extra: {
          textLength: text?.length,
        },
      });
      setCopiedText(null);
      return false;
    }
  };

  return { copiedText, copy };
}
